import { render, staticRenderFns } from "./DatumType.vue?vue&type=template&id=6a797edd&scoped=true&"
import script from "./DatumType.vue?vue&type=script&lang=js&"
export * from "./DatumType.vue?vue&type=script&lang=js&"
import style0 from "./DatumType.vue?vue&type=style&index=0&id=6a797edd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a797edd",
  null
  
)

export default component.exports